import type { SidePanelSizeConfig } from "./side-panel.type";

export const SIDE_PANEL_SIZE: SidePanelSizeConfig = {
  default: undefined, // default Ant Design size
  large: "calc(100% - 200px)", // fill the page to the edge of the main menu
};
